import React, {useState, useEffect} from 'react'
import FinancialResultsSummary from "../components/FinancialResultsSummary";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"
import Loading from '../../Loading';
import { useDashboardContext } from '../../../context/DashboardContext';
import { fetchFinancialResults, fetchFinancialSummary, fetchLatestTanshinQuarterlyFinancialData } from "../../api/api_calls";
import TwoColumnSwitch from '../../utils/TwoColumnSwitch';


const FinancialResultsSummaryTab = ({ secCode, annualQuarter='annual' }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams() 
    const { state: dashboardState, dispatch: dashboardDispatch } = useDashboardContext();
    const [financialSummaryQuarter, setFinancialSummaryQuarter] = useState(null);
    const [financialSummaryAnnual, setFinancialSummaryAnnual] = useState(null);
    const [annualFinancialData, setAnnualFinancialData] = useState(null);
    const [latestQuarterlyFinancialData, setLatestQuarterlyFinancialData] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(annualQuarter ? annualQuarter : 'annual');
    
    // AnnualQuarterSwitch から呼び出されるコールバック関数
    const handlePeriodChange = (period) => {
        setSelectedPeriod(period);
    };

    useEffect(() => {
        const annualQuarter = searchParams.get("annualQuarter")
        if (annualQuarter) {
            if (annualQuarter === 'annual') {
                setSelectedPeriod('annual')
            } else {
                setSelectedPeriod('quarter')
            }
        }
    }, [])

    // secCodeが変更されたときのみ通期データを取得
    useEffect(() => {
        const getFinancialSummary = async (term) => {
            if (term === 'annual') {
                if (dashboardState.financialSummaryAnnual) {
                    setFinancialSummaryAnnual(dashboardState.financialSummaryAnnual);
                } else {
                    const fetchedData = await fetchFinancialSummary(secCode, term, navigate, location);
                    setFinancialSummaryAnnual(fetchedData.data);
                    dashboardDispatch({type: 'SET_FINANCIAL_SUMMARY_ANNUAL', payload: fetchedData.data})
                }
            } else {
                if (dashboardState.financialSummaryQuarter) {
                    setFinancialSummaryQuarter(dashboardState.financialSummaryQuarter);
                } else {
                    const fetchedData = await fetchFinancialSummary(secCode, term, navigate, location);
                    setFinancialSummaryQuarter(fetchedData.data);
                    dashboardDispatch({type: 'SET_FINANCIAL_SUMMARY_QUARTER', payload: fetchedData.data})
                }
            }
        }

        const getFinancialData = async (term) => {
            if (term === 'annual') {
                if (dashboardState.financialData) {
                    setAnnualFinancialData(dashboardState.financialData);
                } else {
                    const fetchedData = await fetchFinancialResults(secCode, navigate, location);
                    setAnnualFinancialData(fetchedData.data);
                    dashboardDispatch({type: 'SET_FINANCIAL_DATA', payload: fetchedData.data})
                }
            } else {
                if (dashboardState.tanshinFinancialDataQuarter) {
                    setLatestQuarterlyFinancialData(dashboardState.tanshinFinancialDataQuarter);
                } else {
                    const fetchedData = await fetchLatestTanshinQuarterlyFinancialData(secCode, navigate, location);
                    setLatestQuarterlyFinancialData(fetchedData.data);
                    dashboardDispatch({type: 'SET_TANSHIN_FINANCIAL_DATA_QUARTER', payload: fetchedData.data})
                }
            }
        }

        getFinancialSummary(selectedPeriod);
        getFinancialData(selectedPeriod);
        if (selectedPeriod) {
            setSearchParams((prevParams) => {
                const newParams = new URLSearchParams(prevParams)
                newParams.set("annualQuarter", selectedPeriod)
                return newParams
            })
        }
    }, [secCode, selectedPeriod]);

    // データの読み込み中の表示
    if (selectedPeriod === "annual" && !financialSummaryAnnual) {
        return <Loading />

    } else if (selectedPeriod === "quarter" && !latestQuarterlyFinancialData) {
        return <Loading />
    }

    const options = [
        {
            id: 'annual', 
            label: '通期'
        },
        {
            id: 'quarter', 
            label: '四半期'
        },
    ]
    
    return (
        <div className="tabcontent">
            <div className="financial-summary-container">
                <div className="dashboard-row" style={{marginTop: 0}}>
                    <div className='mb-4'>
                        <TwoColumnSwitch options={options} onChange={handlePeriodChange} defaultId={selectedPeriod} height={9} />
                    </div>
                    <FinancialResultsSummary 
                        financialSummary={selectedPeriod === 'annual' ? financialSummaryAnnual : financialSummaryQuarter} 
                        financialData={annualFinancialData} 
                        quarterlyFinancialData={latestQuarterlyFinancialData} 
                        selectedPeriod={selectedPeriod} 
                    />
                </div>
            </div>
        </div>
    );
};

export default FinancialResultsSummaryTab;
